import React from "react";
import { Button, Grid, TextField } from "@mui/material";
import colors from "../../../../../colors";
import { useSelector, useDispatch } from "react-redux";
import List from "@material-ui/core/List";
import SingleContract from "../SingleContract";
import { makeStyles } from "@mui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  selectMyContractsState,
  setContractToDelete,
  setCurrentAction,
  setSelectedContractInfo,
  setShouldFillFields,
} from "../../../../../../features/myContracts/myContractsSlice";

const MyContractsUtility = (props) => {
  const useStyles = makeStyles({
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "10px",
        height: "50%",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#FFFFFF",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
        borderRadius: "10px",
        maxHeight: "50%",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
      },
      maxHeight: "400px",
      overflow: "auto",
      paddingLeft: "6%",
      marginTop: 1,
    },
    myContracts: {
      fontFamily: "GerberaBold",
      color: colors.darkBlue,
      textAlign: "left",
      fontSize: "2rem",
    },
    mainGrid: {
      justifyContent: props.utilityName === "" ? "center" : "left",
      "@media (max-width: 899px)": { justifyContent: "center" },
    },
    card: {
      width: props.utilityName === "P2P" ? "50%" : "65%",
      height: "650px",
      // height:props.utilityName === 'P2P' ? '55vh' : '70vh',
      borderRadius: "20px",
      boxShadow: "0 0 15px 5px #E5E7EA",
      "@media (max-width: 1440px )": {
        width:
          props.utilityName === ""
            ? "60%"
            : props.utilityName === "P2P"
            ? "70%"
            : "70%",
      },
      "@media (max-width: 1320px )": {
        width:
          props.utilityName === ""
            ? "60%"
            : props.utilityName === "P2P"
            ? "80%"
            : "100%",
      },
      "@media (max-width: 899px )": { width: "90%" },
    },
    cardBasicAccount: {
      width: props.utilityName === "P2P" ? "50%" : "65%",
      minHeight: "70vh",
      borderRadius: props.utilityName === "" ? "20px" : "20px",
      "@media (max-width: 1440px )": { width: "90%" },
      "@media (max-width: 1320px )": { width: "100%" },
      "@media (max-width: 899px )": { width: "90%" },
    },
    deleteButton: {
      background: colors.white,
      height: "4rem",
      color: colors.gray,
      borderRadius: "100%",
      "&:hover": { background: colors.lightGray },
    },
  });
  const dispatch = useDispatch();
  const myContractsSliceState = useSelector(selectMyContractsState);

  const fillFields = (contract) => {
    var description =
      contract.service === "DPTTV" || "KREDO" || "NOA"
        ? contract.description
        : contract.description === ""
        ? contract.optional
        : contract.description;
    dispatch(
      setSelectedContractInfo({
        contract: contract.contract,
        description: description,
        optional: contract.optional,
        service: contract.service,
      })
    );
    dispatch(setShouldFillFields(true));
  };

  const handleDelete = (contract) => {
    dispatch(
      setContractToDelete(
        contract.service === "DPTTV"
          ? {
              contract: contract.contract + "|" + contract.optional,
              service: contract.service,
            }
          : contract.service === "GJOBAT"
          ? {
              contract: contract.contract,
              description: contract.description,
              optional: contract.optional,
              service: contract.service,
            }
          : { contract: contract.contract, service: contract.service }
      )
    );
    dispatch(setCurrentAction("deleteContract"));
  };

  const classes = useStyles();

  return (
    <List>
      <Grid
        container
        item
        className={classes.scrollBar}
        md={12}
        xs={12}
        spacing={5}
      >
        {props.filteredContracts.map((contract, index) => {
          return (
            <Grid container item md={12} xs={12} key={index}>
              <Grid item md={9.5} xs={9.5}>
                <SingleContract
                  contractData={contract}
                  utilityName={props.utilityName}
                  onClick={() => fillFields(contract)}
                />
              </Grid>
              <Grid pt={"3%"} item md={2.5} xs={2.5}>
                <Button
                  className={classes.deleteButton}
                  onClick={() => handleDelete(contract)}
                  size="small"
                >
                  <DeleteIcon />
                </Button>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </List>
  );
};
export default MyContractsUtility;
